"use client";

import { useLocale, useTranslations } from "next-intl";
import { useActionState } from "react";
import {
  type ContactFormState,
  submitContactForm,
} from "@/app/actions/contact-actions";
import { Form } from "@/components/ui/form";
import {
  SelectField,
  TextareaField,
  TextField,
} from "@/components/ui/form-field";

const initialState: ContactFormState = {
  message: "",
  success: false,
};

export function ContactForm() {
  const t = useTranslations("contactForm");
  const locale = useLocale();
  const [state, formAction] = useActionState<ContactFormState, FormData>(
    submitContactForm,
    initialState,
  );

  const roleOptions = [
    { value: "investor", label: t("roles.investor") },
    { value: "artist", label: t("roles.artist") },
    { value: "collector", label: t("roles.collector") },
    { value: "museum", label: t("roles.museum") },
    { value: "gallery", label: t("roles.gallery") },
    { value: "auction", label: t("roles.auction") },
    { value: "other", label: t("roles.other") },
  ];

  return (
    <div className="bg-white p-6 md:p-12">
      <h4 className="text-xl md:text-2xl font-light mb-4 md:mb-8">
        {t("title")}
      </h4>

      <Form<ContactFormState>
        action={formAction}
        state={state}
        className="space-y-4 md:space-y-8 w-full"
        submitButton={{
          children: t("submitButton"),
          pendingText: t("sendingButton"),
          variant: "default",
        }}
      >
        <input type="hidden" name="locale" value={locale} />

        <div className="grid md:grid-cols-2 gap-6">
          <TextField
            name="name"
            label={t("nameLabel")}
            type="text"
            placeholder={t("namePlaceholder")}
            required
          />
          <TextField
            name="email"
            label={t("emailLabel")}
            type="email"
            placeholder={t("emailPlaceholder")}
            required
          />
        </div>

        <SelectField
          name="role"
          label={t("roleLabel")}
          placeholder={t("rolePlaceholder")}
          options={roleOptions}
          required
        />

        <TextareaField
          name="message"
          label={t("messageLabel")}
          placeholder={t("messagePlaceholder")}
          rows={6}
          required
        />
      </Form>
    </div>
  );
}
